import { initFooterSection } from "@/modules/section-footer";
import { initLazyBackgrounds } from "@/scripts/helpers/lazy.js"
import ready from "@/scripts/helpers/dom/ready";
import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';
import cookiePopup from "@/modules/popup-cookie";
// import { clickTracker } from "@/scripts/helpers/clickTracker";

import { headerFunctions } from "@/modules/section-header";

let sliderNavigation;


const sliderPhone = new Swiper(".js-slider-phone", {
	autoplay: {
		delay: 5000,
		disableOnInteraction: false
	},
	spaceBetween: 0,
	slidersPerView: 1,
	initialSlide: 0,
	centeredSlides: true,
	effect: 'fade',
	fadeEffect: { crossFade: true },
	loop: true,
	modules: [Autoplay, EffectFade],
}); 



function animateCircle(el) {
	const duration = 5000;
	const startingOffset = 150.79644737231007;
	const endingOffset = 0;

	let startTime;

	function animate(currentTime) {
		if (!startTime) {
			startTime = currentTime;
		}

		const elapsedTime = currentTime - startTime;
		const progress = Math.min(elapsedTime / duration, 1);  
		const newOffset = startingOffset - (progress * (startingOffset - endingOffset));
		el.setAttribute('stroke-dashoffset', newOffset);

		if (progress < 1) {
			requestAnimationFrame(animate);
		}
	}
	requestAnimationFrame(animate);
}

function resetCircleStyles(el) {
	el.removeAttribute('style');
}

function startCircleAnimation(el) {
	animateCircle(el);
}

function initFirstSlide(sliderNavigation) {
	const panel = sliderNavigation[0];
	const panelTitle = panel.querySelector('.slide__title');
	const panelIcon = panel.querySelector('.slide__icon-circle--outer');
	if (panelTitle.getAttribute('aria-selected') !== 'true') {
		panelTitle.setAttribute('aria-selected', 'true');
		panel.classList.add('is-active');
		// resetCircleStyles(panelIcon);
		startCircleAnimation(panelIcon);
	}
}

if (window.innerWidth >= 768) {
	sliderNavigation = document.querySelectorAll('.js-slider-navigation .slide-navigation');
	sliderPhone.allowTouchMove = false;
	sliderPhone.update();
	sliderNavigation.forEach((panel, index) => {
		panel.addEventListener('click', e => {
			const panelTitle = panel.querySelector('.slide__title');
	
			if (panelTitle.getAttribute('aria-selected') !== 'true') {
				e.preventDefault();
				sliderPhone.slideToLoop(index);
				sliderPhone.autoplay.start();
			}
		});
	});
} else {
	// sliderNavigation = document.querySelectorAll('.js-slider-phone .slide-navigation');
	sliderNavigation = [];
	sliderNavigation[0] = document.querySelector('.js-slider-phone .swiper-slide--1');
	sliderNavigation[1] = document.querySelector('.js-slider-phone .swiper-slide--2');
	sliderNavigation[2] = document.querySelector('.js-slider-phone .swiper-slide--3');
	sliderNavigation[3] = document.querySelector('.js-slider-phone .swiper-slide--4');
} 


sliderPhone.on('realIndexChange', () => {
	const activeSlideIndex = sliderPhone.realIndex;
	// if (window.innerWidth >= 768) {
	// 	sliderNavigation = document.querySelectorAll('.js-slider-navigation .slide-navigation');
	// } else {
	// };

	sliderNavigation.forEach((panel, index) => {
		const panelTitle = panel.querySelector('.slide__title');
		const panelIcon = panel.querySelector('.slide__icon-circle--outer');
		
		if (index === activeSlideIndex) {
			panelTitle.setAttribute('aria-selected', 'true');
			panel.classList.add('is-active');
			resetCircleStyles(panelIcon);
			startCircleAnimation(panelIcon);

		} else {
			panelTitle.setAttribute('aria-selected', 'false');
			panel.classList.remove('is-active');
			resetCircleStyles(panelIcon);

		}
	})
});



function sliderStart(sliderNavigation) {
	const elementToObserve = document.querySelector('.js-slider-phone');
	const observer = new IntersectionObserver(activateNavigationPanels, { threshold: 0.5 });
	
	function activateNavigationPanels(entries) {
		const entry = entries[0];
		if (entry.isIntersecting) {
			initFirstSlide(sliderNavigation);
			sliderPhone.slideToLoop(0);
			sliderPhone.autoplay.start();
			observer.unobserve(entry.target);
		}
	};
	observer.observe(elementToObserve);
}

ready(() => {
	headerFunctions();
	sliderStart(sliderNavigation);
	initLazyBackgrounds();
	initFooterSection();
	// clickTracker();
	setTimeout(() => {
		cookiePopup();
	}, 4000);
});